import React from 'react';
import PropTypes from 'prop-types';
import i18n from 'src/utils/translate';
import PostListCard from 'src/modules/community/shared/components/sidebar/postListCard';
import { trackFootfallEventWithHrefDelay } from 'src/utils/footfall';
import footfallEventTypes from 'src/constants/footfallEventTypes';

const CommunityPostsPinnedPosts = ({ community, posts }) => (
  <PostListCard
    community={community}
    posts={posts}
    postType={'pinned-post'}
    seeAllLink={`/${community.slug}/posts/#pinned`}
    seeAllOnClick={e => {
      e.preventDefault();
      trackFootfallEventWithHrefDelay(`/${community.slug}/posts/#pinned`, footfallEventTypes.CLICKED, {
        clickType: 'see-all-pinned-posts',
        clickMetadata: { section: 'community-posts-side-bar' },
      });
    }}
    title={i18n.t('Pinned Posts')}
  />
);

CommunityPostsPinnedPosts.propTypes = {
  community: PropTypes.object.isRequired,
  posts: PropTypes.array.isRequired,
};

export default CommunityPostsPinnedPosts;
